'use client';
import {Button, ButtonProps} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {useAppRouter} from '../../providers';

export const BackButton = ({
  sx,
  href,
  onClick,
  children,
  ...props
}: ButtonProps & {
  href?: string;
}) => {
  const router = useAppRouter();
  return (
    <Button
      color="inherit"
      sx={{
        padding: 1,
        color: 'inherit',
        minWidth: 0,
        textTransform: 'capitalize',
        ...sx,
      }}
      {...props}
      onClick={e => {
        href
          ? router.replace(href)
          : onClick
          ? onClick(e)
          : window.history.back();
      }}
    >
      <KeyboardBackspaceIcon sx={{mr: 1}} />
      {children}
    </Button>
  );
};
